{
  "addons.addonList": "Lista de complementos",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Genere y obtenga la clave API desde este enlace",
  "addons.ambientWeatherDescription": "Estación Meteorológica Ambient Weather (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "Clave API",
  "addons.applicationKey": "Clave de programa",
  "addons.connect": "Conectarse",
  "addons.davisApiSecret": "Secreto de la API",
  "addons.davisApiV2Key": "Clave API V2",
  "addons.davisDescription": "Estación Meteorológica Davis (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Obtenga la clave API V2 de este enlace",
  "addons.disconnect": "Desconectarse",
  "addons.ecowittCreateAndRetrieveKeys": "Genere y recupere una clave API y una clave de aplicación desde este enlace",
  "addons.ecowittDescription": "Ecowitt ofrece estación meteorológica wifi profesional, termómetros inalámbricos para interior y exterior, medidor de humedad, pluviómetro de alta precisión, medidor de calidad del aire, etc.",
  "addons.helpLink": "Cómo conectar {provider}",
  "addons.myAcuriteAccountOnHold": "Su cuenta ha sido suspendida. Por favor ingrese su contraseña para volver a conectar su cuenta",
  "addons.myAcuriteDescription": "AcuRite es la marca de estaciones meteorológicas número uno en Norteamérica. Como líder en tecnología de tiempo, temperatura y clima, AcuRite le proporciona información detallada sobre su entorno interior y exterior para que pueda planificar su día con confianza.",
  "addons.myAcuriteEnterCredentials": "Ingrese sus credenciales de My AcuRite para vincular su cuenta My AcuRite con SmartMixin",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Use su Termostato Netatmo para cambiar la temperatura de su hogar, desde su cama o desde el otro lado del mundo.",
  "addons.netatmoThermostat": "Termostato Netatmo",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Sus mediciones meteorológicas en su móvil.",
  "addons.or": "o",
  "addons.providerAccountDisconnected": "La conexión con su servicio meteorológico ha expirado. Vuelva a conectarse para reanudar las actualizaciones de datos.",
  "addons.reconnect": "Reconectar",
  "addons.weatherflowCreateToken": "Crea y obtén tu token desde este enlace",
  "addons.weatherflowTempestDescription": "Sistema meteorológico Tempest con pluviómetro y viento integrado",
  "addons.wundergroundApiKey": "Clave API",
  "addons.wundergroundDescription": "Weather Underground es una comunidad global de personas que conectan datos de sensores ambientales como estaciones meteorológicas y monitores de calidad del aire, por lo que podemos proporcionar los datos hiperlocales que necesita para ejecutar sus pasatiempos.",
  "addons.wundergroundRetrieveApiKey": "Obtenga su clave API usando este enlace",
  "addons.wundergroundRetrieveStationId": "Obtenga su ID de estación con este enlace",
  "addons.wundergroundStationId": "Identificación de la estación",
  "airQuality.airQuality": "Calidad del aire",
  "airQuality.airQualityIndex": "Índice de calidad del aire",
  "airQuality.aqiForecast": "Pronóstico de calidad del aire",
  "airQuality.co": "Monóxido de carbono",
  "airQuality.dailyForecast": "Advertencia a largo plazo",
  "airQuality.details": "Detalles",
  "airQuality.dominantPollutant": "Contaminante dominante",
  "airQuality.good": "Buena",
  "airQuality.goodDescription": "No se anticipan impactos a la salud cuando la calidad del aire se encuentra en este intervalo.",
  "airQuality.hazardous": "Arriesgado",
  "airQuality.hazardousDescription": "Advertencia de salud: todos pueden experimentar efectos de salud más graves",
  "airQuality.indoorAirQuality": "Calidad del aire interior",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Moderada",
  "airQuality.moderateDescription": "Las personas extraordinariamente sensitivas deben considerar limitación de los esfuerzos físicos excesivos y prolongados al aire libre.",
  "airQuality.no2": "Dioxido de nitrogeno",
  "airQuality.o3": "Ozono",
  "airQuality.pm10": "Partículas con un diámetro de 10 μm o menos",
  "airQuality.pm25": "Partículas con un diámetro de 2,5 μm o menos",
  "airQuality.ppb": "ppb",
  "airQuality.sensitiveUnhealthy": "Dañina a la Salud de los Grupos Sensitivos",
  "airQuality.sensitiveUnhealthyDescription": "Los niños y adultos activos, y personas con enfermedades respiratorias tales como el asma, deben evitar los esfuerzos físicos excesivos y prolongados al aire libre.",
  "airQuality.so2": "Dióxido de azufre",
  "airQuality.ugm3": "µg/m³",
  "airQuality.unhealthy": "Dañina a la Salud",
  "airQuality.unhealthyDescription": "Los niños y adultos activos, y personas con enfermedades respiratorias tales como el asma, deben evitar los esfuerzos excesivos prolongados al aire libre; las demás personas, especialmente los niños, deben limitar los esfuerzos físicos excesivos y prolongados al aire libre.",
  "airQuality.veryUnhealthy": "Muy Dañina a la Salud",
  "airQuality.veryUnhealthyDezscription": "Los niños y adultos activos, y personas con enfermedades respiratorias tales como el asma, deben evitar todos los esfuerzos excesivos al aire libre; las demás personas, especialmente los niños, deben limitar los esfuerzos físicos excesivos al aire libre.",
  "alerts.addAlert": "Agregar alerta",
  "alerts.addCondition": "Agregar condición",
  "alerts.alertAdded": "Se ha añadido el aviso.",
  "alerts.alertAuthorizationNotice": "Las notificaciones solo funcionan si autoriza a SmartMixin a mostrar notificaciones",
  "alerts.alertDeleted": "La alerta fue eliminada",
  "alerts.alertEdited": "El aviso cambió",
  "alerts.alertName": "Nombre de alerta",
  "alerts.alertWhen": "Seré notificado cuando:",
  "alerts.aqiGreaterThan": "ICA superior a",
  "alerts.aqiGreaterThanThreshold": "AQI superior al límite de {value}{unit}",
  "alerts.aqiLessThan": "ICA inferior a",
  "alerts.aqiLessThanThreshold": "AQI inferior al límite de {value}{unit}",
  "alerts.atLeastOneCondition": "Debe agregar al menos una condición",
  "alerts.co2GreaterThan": "CO2 superior a",
  "alerts.co2GreaterThanThreshold": "CO2 superior al límite de {value}{unit}",
  "alerts.co2LessThan": "CO2 inferior a",
  "alerts.co2LessThanThreshold": "CO2 inferior al límite de {value}{unit}",
  "alerts.conditions": "Condiciones",
  "alerts.createAlert": "Crear notificación",
  "alerts.dailyPrecipitationGreaterThan": "Precipitación diaria superior a",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Precipitación diaria superior al umbral de {value}{unit}",
  "alerts.deleteAlert": "Eliminar notificación",
  "alerts.editAlert": "Editar notificación",
  "alerts.editCondition": "Editar condiciones",
  "alerts.gustSpeedGreaterThan": "Ráfaga más alta que",
  "alerts.gustSpeedGreaterThanThreshold": "Ráfaga de viento superior al límite de {value}{unit}",
  "alerts.gustSpeedLessThan": "Ráfaga más baja que",
  "alerts.gustSpeedLessThanThreshold": "Ráfaga de viento inferior al límite de {value}{unit}",
  "alerts.heatIndexGreaterThan": "Índice de calor superior a",
  "alerts.heatIndexGreaterThanThreshold": "Índice de calor superior al límite de {value}{unit}",
  "alerts.heatIndexLessThan": "Índice de calor inferior a",
  "alerts.heatIndexLessThanThreshold": "Índice de calor inferior al límite de {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex superior a",
  "alerts.humidexGreaterThanThreshold": "Humidex superior al límite de {value}{unit}",
  "alerts.humidexLessThan": "Humidex inferior a",
  "alerts.humidexLessThanThreshold": "Humidex inferior al límite de {value}{unit}",
  "alerts.humidityGreaterThan": "Humedad superior a",
  "alerts.humidityGreaterThanThreshold": "Humedad superior al límite de {value}{unit}",
  "alerts.humidityLessThan": "Humedad inferior a",
  "alerts.humidityLessThanThreshold": "Humedad inferior al límite de {value}{unit}",
  "alerts.inProgress": "En curso",
  "alerts.myAlerts": "Mis Notificaciones",
  "alerts.noConfiguredAlert": "Aún no has configurado ninguna notificación, empieza por añadir una",
  "alerts.noiseGreaterThan": "Ruido más fuerte que",
  "alerts.noiseGreaterThanThreshold": "Ruido superior al límite de {value}{unit}",
  "alerts.noiseLessThan": "Ruido inferior a",
  "alerts.noiseLessThanThreshold": "Ruido inferior al límite de {value}{unit}",
  "alerts.noteOnConditions": "Tenga en cuenta que la alerta se activa cuando se confirman todas las condiciones a continuación",
  "alerts.pm10GreaterThan": "PM 10 más alto que",
  "alerts.pm10GreaterThanThreshold": "PM 10 límite de reflujo superior de {value}{unit}",
  "alerts.pm10LessThan": "PM 10 más bajo que",
  "alerts.pm10LessThanThreshold": "PM 10 por debajo del límite de {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 más alto que",
  "alerts.pm1GreaterThanThreshold": "PM 1 superior al límite de {value}{unit}",
  "alerts.pm1LessThan": "PM 1 inferior a",
  "alerts.pm1LessThanThreshold": "PM 1 inferior al límite de {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2.5 más alto que",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 más alto que el límite de {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2.5 más bajo que",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 por debajo del límite de {value}{unit}",
  "alerts.postStormSummary": "Resumen de la tormenta",
  "alerts.postStormSynopsisHelper": "Recibirás una notificación de resumen al final de cada tormenta de lluvia.",
  "alerts.postStormSynopsisSoleCondition": "Un resumen posterior a la tormenta no se puede combinar con otras condiciones.",
  "alerts.precipitationGreaterThan": "Precipitación horaria superior a",
  "alerts.precipitationGreaterThanThreshold": "Precipitación horaria superior al umbral de {value}{unit}",
  "alerts.pressureGreaterThan": "Presión de aire superior a",
  "alerts.pressureGreaterThanThreshold": "Presión de aire superior al límite de {value}{unit}",
  "alerts.pressureLessThan": "Presión de aire inferior a",
  "alerts.pressureLessThanThreshold": "Presión de aire inferior al límite de {value}{unit}",
  "alerts.rainRateGreaterThan": "Intensidad de lluvia superior a",
  "alerts.rainRateGreaterThanThreshold": "Intensidad de lluvia superior al umbral de {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Radiación solar superior a",
  "alerts.solarRadiationGreaterThanThreshold": "Radiación solar superior al límite de {value}{unit}",
  "alerts.solarRadiationLessThan": "Radiación solar inferior a",
  "alerts.solarRadiationLessThanThreshold": "Radiación solar inferior al límite de {value}{unit}",
  "alerts.temperatureGreaterThan": "Temperatura superior a",
  "alerts.temperatureGreaterThanThreshold": "Temperatura superior al límite de {value}{unit}",
  "alerts.temperatureLessThan": "Temperatura inferior a",
  "alerts.temperatureLessThanThreshold": "Temperatura inferior al límite de {value}{unit}",
  "alerts.thswGreaterThan": "THSW superior a",
  "alerts.thswGreaterThanThreshold": "THSW superior al límite de {value}{unit}",
  "alerts.thswLessThan": "THSW inferior a",
  "alerts.thswLessThanThreshold": "THSW inferior al límite de {value}{unit}",
  "alerts.thwGreaterThan": "THW superior a",
  "alerts.thwGreaterThanThreshold": "THW superior al límite de {value}{unit}",
  "alerts.thwLessThan": "THW inferior a",
  "alerts.thwLessThanThreshold": "THW inferior al límite de {value}{unit}",
  "alerts.uvGreaterThan": "Índice UV superior a",
  "alerts.uvGreaterThanThreshold": "Índice UV superior al límite de {value}{unit}",
  "alerts.uvLessThan": "Índice UV inferior a",
  "alerts.uvLessThanThreshold": "Índice UV inferior al límite de {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Visibilidad mayor que el límite de {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Visibilidad menor que el límite de {value}{unit}",
  "alerts.visiblityGreaterThan": "Visibilidad mayor que",
  "alerts.visiblityLessThan": "Visibilidad menor que",
  "alerts.whichMeasure": "¿De qué medidas quieres que te avisemos?",
  "alerts.whichModule": "¿A qué módulo le gustaría ser alertado?",
  "alerts.windChillGreaterThan": "Sensación térmica superior a",
  "alerts.windChillGreaterThanThreshold": "Sensación térmica superior al límite de {value}{unit}",
  "alerts.windChillLessThan": "Sensación térmica inferior a",
  "alerts.windChillLessThanThreshold": "Sensación térmica inferior al límite de {value}{unit}",
  "alerts.windSpeedGreaterThan": "La velocidad del viento es superior a",
  "alerts.windSpeedGreaterThanThreshold": "La velocidad del viento es superior al límite de {value}{unit}",
  "alerts.windSpeedLessThan": "La velocidad del viento es inferior a",
  "alerts.windSpeedLessThanThreshold": "La velocidad del viento es inferior al límite de {value}{unit}",
  "astral.astronomicalSunPhase": "astronómico {sunPhase}",
  "astral.civilSunPhase": "Civil {sunPhase}",
  "astral.dawn": "Alba",
  "astral.dusk": "Oscuridad",
  "astral.firstQuarter": "Primer cuarto",
  "astral.fullMoon": "Luna llena",
  "astral.lastQuarter": "Último cuarto",
  "astral.moon": "Luna",
  "astral.moonPhases": "Fases de la luna",
  "astral.moonrise": "salida de la luna",
  "astral.moonset": "Puesta de luna",
  "astral.nauticalSunPhase": "Náutica {sunPhase}",
  "astral.newMoon": "Luna nueva",
  "astral.noon": "Mediodía",
  "astral.remainingDaylight": "Luz diurna restante",
  "astral.sunrise": "Amanecer",
  "astral.sunriseAndSunset": "amanecer y el atardecer",
  "astral.sunriseAt": "Amanecer a las {time}",
  "astral.sunset": "Atardecer",
  "astral.sunsetAt": "Atardecer a las {time}",
  "astral.totalDaylight": "Luz diurna total",
  "astral.waningCrescent": "Luna creciente menguante",
  "astral.waningGibbous": "Luna menguante (Ne)",
  "astral.waxingCrescent": "Luna creciente",
  "astral.waxingGibbous": "Luna Creciente (Nueva)",
  "auth.alreadyHaveAccount": "¿Ya tienes una cuenta?",
  "auth.authContainerTagline": "Tu panel meteorológico personal. Conecta tus estaciones y obtén datos en tiempo real al alcance de tu mano.",
  "auth.backToLogin": "Volver al inicio de sesión",
  "auth.catchPhrase": "La plataforma de inteligencia meteorológica",
  "auth.checkYourEmail": "Revisa tu correo electrónico",
  "auth.continueWithApple": "Continuar con Apple",
  "auth.continueWithFacebook": "Continuar con Facebook",
  "auth.continueWithGoogle": "Continuar con Google",
  "auth.email": "Dirección de correo electrónico",
  "auth.emailRequiredLoginFacebook": "Se necesita el correo electrónico para conectarse con Facebook",
  "auth.emailVerification": "Verificacion de email",
  "auth.emailVerificationFailure": "Hubo un problema con su correo electrónico de confirmación.",
  "auth.emailVerificationSuccess": "Su correo electrónico ha sido verificado.",
  "auth.firstName": "Nombre",
  "auth.forgotPassword": "Contraseña olvidada",
  "auth.forgotPasswordSubtitle": "Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.",
  "auth.lastName": "Apellido",
  "auth.login": "Conectarse",
  "auth.loginSubtitle": "¡Bienvenido de nuevo! Por favor, ingresa tus datos.",
  "auth.loginToSmartMixinDescription": "Ingrese sus credenciales de SmartMixin para acceder a su cuenta.",
  "auth.logout": "Desconectarse",
  "auth.logoutConfirmation": "¿Está seguro de que desea cerrar la sesión?",
  "auth.noAccountYet": "¿No tienes una cuenta?",
  "auth.or": "o",
  "auth.password": "Contraseña",
  "auth.passwordAgain": "Contraseña de nuevo",
  "auth.passwordReset": "Restablecer la contraseña",
  "auth.passwordResetSuccess": "Su contraseña ha sido actualizada.",
  "auth.register": "Registrarse",
  "auth.registerDescription": "Crea una cuenta SmartMixin gratuita para conectar tus estaciones meteorológicas, seguir los datos del tiempo y acceder a potentes herramientas de análisis.",
  "auth.registerSubtitle": "Crea tu cuenta para comenzar.",
  "auth.registerSuccess": "¡Te has registrado correctamente! Acabamos de enviarte un enlace de verificación a {emailAddress} con más instrucciones.",
  "auth.restorePassword": "Restaurar contraseña",
  "auth.restorePasswordSuccess": "Acabamos de enviarle un enlace para restablecer la contraseña a {emailAddress} con más instrucciones.",
  "auth.sendReset": "Enviar instrucciones de restablecimiento",
  "auth.socialAccount": "o usa tu cuenta",
  "auth.welcome": "Bienvenido a SmartMixin",
  "auth.welcomeBack": "¡Bienvenido de nuevo!",
  "calendar.april": "Abril",
  "calendar.august": "Agosto",
  "calendar.dateFormat": "Formato de fecha",
  "calendar.day": "Día",
  "calendar.december": "Diciembre",
  "calendar.end": "Fin",
  "calendar.february": "Febrero",
  "calendar.hours": "horas",
  "calendar.hoursShort": "horas",
  "calendar.january": "Enero",
  "calendar.july": "Julio",
  "calendar.june": "Junio",
  "calendar.last24Hours": "Últimas 24 horas",
  "calendar.last30Days": "últimos 30 días",
  "calendar.last7Days": "Los últimos 7 días",
  "calendar.march": "Marzo",
  "calendar.max": "Máx",
  "calendar.may": "Mayo",
  "calendar.month": "Mes",
  "calendar.months": "meses",
  "calendar.november": "Noviembre",
  "calendar.october": "Octubre",
  "calendar.oneDay": "1 día",
  "calendar.oneHour": "1 hora",
  "calendar.oneMonth": "1 mes",
  "calendar.oneWeek": "1 semana",
  "calendar.previous24Hours": "Últimas 24 horas",
  "calendar.previous30Days": "Últimos 30 días",
  "calendar.previous7Days": "Los últimos 7 días",
  "calendar.previousDay": "El día anterior",
  "calendar.previousMonth": "Mes anterior",
  "calendar.previousWeek": "Semana pasada",
  "calendar.previousYear": "Año anterior",
  "calendar.sameDayLastYear": "El mismo día del año pasado",
  "calendar.sameMonthLastYear": "El mismo mes del año pasado",
  "calendar.selectADate": "Seleccione una fecha",
  "calendar.selectAMonth": "Seleccione un mes",
  "calendar.selectAYear": "Seleccione un año",
  "calendar.selectGranularity": "Seleccionar una granularidad",
  "calendar.selectTimescale": "Seleccionar una escala de tiempo",
  "calendar.september": "Septiembre",
  "calendar.sixHours": "6 horas",
  "calendar.start": "Comienzo",
  "calendar.thirtyMinutes": "30 minutos",
  "calendar.threeHours": "3 horas",
  "calendar.use24HourFormat": "Usar el formato de 24 horas",
  "calendar.week": "Semana",
  "calendar.year": "Año",
  "calendar.yesterday": "Ayer",
  "common.accountDeleted": "Tu cuenta ha sido eliminada.",
  "common.accountOnHold": "La conexión de su cuenta ha expirado. Vuelva a conectarse para reanudar las actualizaciones de datos.",
  "common.add": "agregar",
  "common.addAStation": "Agregar una estación",
  "common.addToFavorites": "Agregar a los favoritos",
  "common.addYourOwnStation": "Agrega tu propia estación",
  "common.alreadyPremium": "¡Ya tiene una cuenta premium!",
  "common.alsoAvailableOn": "También disponible en:",
  "common.altitude": "Altitud",
  "common.analysis": "Análisis",
  "common.aroundMe": "A mi alrededor",
  "common.articleCount": "{count, plural, one {count} artículo} other {count} artículos}}",
  "common.articleNotFound": "Artículo no encontrado",
  "common.articleNotFoundDescription": "El artículo que buscas no existe.",
  "common.average": "Regular",
  "common.averageOverThePeriod": "Promedio durante el período",
  "common.away": "Ausente",
  "common.back": "Atrás",
  "common.backToHelpCenter": "Volver al centro de ayuda",
  "common.backToHome": "Volver al Inicio",
  "common.bad": "Malo",
  "common.batteryLevel": "Nivel de batería",
  "common.bestValue": "Mejor Oferta",
  "common.billingDetailsAndroid": "Para la oferta de prueba gratuita, no se le cobrará si cancela 24 horas antes de que expire el período de introducción gratuito. Cuando finalice la prueba, puede cancelar la suscripción a SmartMixin en cualquier momento a través de la configuración de su cuenta de Google Play, o se renovará automáticamente. Esto debe hacerse 24 horas antes del final del período de suscripción para evitar que se le cobre otra tarifa que se muestra en el botón de arriba. Los pagos de suscripción se cargarán a su cuenta de Google Play en la confirmación de su compra y al comienzo de cada plazo de renovación.",
  "common.billingDetailsIos": "Para la oferta de prueba gratuita, no se le cobrará si cancela 24 horas antes de que expire el período de introducción gratuito. Cuando finalice la prueba, puede cancelar la suscripción a SmartMixin en cualquier momento a través de la configuración de su cuenta de la App Store, o se renovará automáticamente. Esto debe hacerse 24 horas antes del final del período de suscripción para evitar que se le cobre otra tarifa que se muestra en el botón de arriba. Los pagos de suscripción se cargarán a su cuenta de App Store en la confirmación de su compra y al comienzo de cada plazo de renovación.",
  "common.boilerOn": "Calentador encendido",
  "common.browseByCategory": "Explorar por categoría",
  "common.calendarView": "Vista de calendario",
  "common.cancel": "Cancelar",
  "common.cannotBeEmpty": "Este campo no puede estar vacío.",
  "common.cardDetails": "Detalles de tarjeta",
  "common.categoryNotFound": "Categoría no encontrada",
  "common.categoryNotFoundDescription": "Esta categoría no existe o no tiene artículos.",
  "common.charts": "Gráficos",
  "common.chartView": "Vista de gráfico",
  "common.clearRecentLocations": "Despejar todo",
  "common.close": "Cerrar",
  "common.comparison": "Comparación",
  "common.currentDay": "Día actual",
  "common.currentLocation": "Ubicación actual",
  "common.currentObservations": "última medición",
  "common.currentRainEvent": "Evento de lluvia actual",
  "common.currentRate": "Cantidad actual",
  "common.currentWeatherConditions": "Condiciones actuales",
  "common.customizeComparisonMetrics": "Personalizar métricas de comparación",
  "common.customizeComparisonMetricsDescription": "Arrastra los elementos para reordenar tus métricas de comparación. Toca el icono del ojo para mostrar u ocultar métricas.",
  "common.customizeDashboard": "Personalizar",
  "common.customizeDashboardDescription": "Arrastra los elementos para reordenar tu panel. Toca el icono del ojo para mostrar u ocultar secciones.",
  "common.customizedStationName": "Nombre de la estación personalizada",
  "common.dailyForecast": "Advertencia a largo plazo",
  "common.dashboard": "Dashboard",
  "common.default": "Predeterminado",
  "common.defaultForecastModelChip": "Predeterminado · {name}",
  "common.delete": "Borrar",
  "common.deleteAccount": "eliminar tu cuenta",
  "common.deleteAccountConfirmation": "¿Está seguro de que desea eliminar su cuenta? ¡No puede deshacer si elimina su cuenta!",
  "common.deleteAccountDescription": "Esta acción elimina su cuenta y toda su información. No hay vuelta atrás.",
  "common.details": "Detalles",
  "common.edit": "Editar",
  "common.editor": "Editor",
  "common.endTime": "Hora de finalización",
  "common.exitFullscreen": "Salir de pantalla completa",
  "common.exploreWeatherMap": "Explorar Mapa del Tiempo",
  "common.favoriteLocations": "Favoritos",
  "common.favoriteLocationsEmpty": "Puede agregar hasta 5 ubicaciones favoritas.",
  "common.favoriteStations": "Estaciones favoritas",
  "common.feedbackHelpsImprove": "Tus comentarios nos ayudan a mejorar nuestros artículos de ayuda.",
  "common.filterStationDescription": "No muestre estaciones con medidas poco confiables",
  "common.filterStations": "Filtrar los estaciones",
  "common.filterStationSourceDescription": "Seleccione los proveedores de estaciones que desea mostrar en el mapa",
  "common.findStationsNearYou": "Encontrar estaciones cerca de ti",
  "common.firmwareVersion": "Versión de firmware",
  "common.forecast": "Pronóstico",
  "common.forecastComparisonDescription": "Compare fácilmente los datos del modelo de pronóstico de múltiples fuentes",
  "common.forecastModelComparison": "Comparación de modelos de pronóstico",
  "common.forecastModelCoverage": "Cobertura",
  "common.forecastModelDescription": "Descripción",
  "common.forecastModelDescription_AROME": "Modelo de alta resolución de Météo France con resolución de convección sobre Europa occidental a 1,3 km. El mejor en su clase para previsiones a corto plazo en Francia; se actualiza cada tres horas.",
  "common.forecastModelDescription_ARPEGE_EU": "El nido europeo del modelo ARPEGE de Météo France con resolución de 10 km. Previsiones a medio plazo sobre Europa, actualizadas cuatro veces al día.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Modelo global numérico del tiempo de Météo France con resolución de 25 km, hasta unos 4 días. Actualizado cuatro veces al día.",
  "common.forecastModelDescription_EC_GDPS": "Sistema Global Determinista de Predicción de Environment Canada: un modelo mundial a medio plazo con resolución de 15 km que llega hasta 10 días, actualizado dos veces al día.",
  "common.forecastModelDescription_EC_RDPS": "Sistema Regional Determinista de Predicción de Environment Canada: un modelo a medio plazo sobre Norteamérica con resolución de 10 km, actualizado cuatro veces al día.",
  "common.forecastModelDescription_GFS": "El modelo global emblemático a medio plazo de la NOAA. Cubre todo el planeta con resolución de 25 km hasta 16 días, actualizado cuatro veces al día.",
  "common.forecastModelDescription_HRRR_CONUS": "El High-Resolution Rapid Refresh de la NOAA: un modelo con resolución de convección sobre los Estados Unidos continentales a 3 km, actualizado cada hora. Adecuado para previsiones a muy corto plazo de tormentas y meteorología severa.",
  "common.forecastModelDescription_ICON_DE": "Modelo de alta resolución de DWD con resolución de convección sobre Alemania y países circundantes a 2,2 km. Previsiones a corto plazo actualizadas dos veces al día.",
  "common.forecastModelDescription_ICON_EU": "El nido europeo del modelo ICON de DWD con resolución de 7 km que cubre Europa y el Atlántico norte. Previsiones a medio plazo actualizadas cuatro veces al día.",
  "common.forecastModelDescription_MET_NORWAY": "El servicio abierto de previsión meteorológica del Instituto Meteorológico Noruego, que combina modelos nórdicos de alta resolución con datos del ECMWF para ofrecer previsiones mundiales hasta 10 días.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "Nido AROME sobre las Antillas francesas (Guadalupe, Martinica) a 2,5 km de resolución. Previsiones a corto plazo actualizadas cuatro veces al día.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "Nido AROME sobre la Guayana Francesa a 2,5 km de resolución. Previsiones a corto plazo actualizadas cuatro veces al día.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "Nido AROME sobre Nueva Caledonia a 2,5 km de resolución. Previsiones a corto plazo actualizadas cuatro veces al día.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "Nido AROME sobre la Polinesia Francesa a 2,5 km de resolución. Previsiones a corto plazo actualizadas cuatro veces al día.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "Nido AROME sobre Reunión y Mayotte a 2,5 km de resolución. Previsiones a corto plazo actualizadas cuatro veces al día.",
  "common.forecastModelDescription_NAM_CONUS": "Nido del modelo North American Mesoscale de la NOAA sobre los Estados Unidos continentales a 5 km de resolución. Previsiones a corto plazo actualizadas cuatro veces al día.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "El modelo North American Mesoscale de la NOAA que cubre toda Norteamérica con resolución de 32 km. Actualizado cuatro veces al día.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "Previsión insignia de SmartMixin. Para cada hora en tu ubicación, elegimos el mejor modelo disponible — normalmente un modelo regional de alta resolución cuando existe uno (AROME en Francia, ICON-D2 en Alemania, HRRR en EE. UU., ARPEGE Europe en el continente…) y recurrimos a un modelo global en otros lugares — y luego rellenamos las lagunas con fuentes vecinas. El resultado es una única previsión continua que cubre cualquier lugar del mundo hasta 14 días, actualizada automáticamente cada vez que se actualiza alguno de los modelos subyacentes.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Previsión global propietaria de Weatherflow que combina múltiples modelos meteorológicos numéricos con observaciones de su red de estaciones meteorológicas Tempest. Horizonte mundial de 10 días.",
  "common.forecastModelDetailTitle": "Modelo de previsión",
  "common.forecastModelScopeGlobal": "Global",
  "common.forecastModelScopeGlobalDescription": "Este modelo cubre todo el planeta.",
  "common.forecastModelScopeRegional": "Regional",
  "common.forecastModelScopeRegionalDescription": "Este modelo solo cubre una región específica.",
  "common.forecastModelSpecifications": "Especificaciones",
  "common.forecastSources": "Fuentes de pronóstico",
  "common.freeAccount": "Cuenta gratuita",
  "common.freeSubscription": "Suscripción Premium gratuita",
  "common.freeTrialForPeriod": "Prueba gratuita durante {period} días",
  "common.frequency": "Frecuencia",
  "common.full": "Completo",
  "common.fullscreen": "Pantalla completa",
  "common.getStartedFree": "Comenzar Gratis",
  "common.getUnlimitedAccess": "Acceso ilimitado a:",
  "common.good": "Bueno",
  "common.hail": "Granizo",
  "common.help": "Ayuda",
  "common.helpCategoryAccount": "Cuenta",
  "common.helpCategoryBilling": "Facturación",
  "common.helpCategoryGettingStarted": "Primeros pasos",
  "common.helpCategoryProviders": "Proveedores",
  "common.helpCategoryStations": "Estaciones",
  "common.helpCategoryTroubleshooting": "Solución de problemas",
  "common.helpCenter": "Centro de ayuda",
  "common.helpCenterDescription": "Encuentra respuestas a preguntas frecuentes y aprende a sacar el máximo provecho de SmartMixin.",
  "common.hg": "Frost guard",
  "common.hidden": "Ocultos",
  "common.hiddenSensors": "Sensores ocultos",
  "common.hiddenStations": "Estaciones ocultas",
  "common.hiddenStationsDescription": "Puede hundir una estación tocando el ícono del ojo al lado.",
  "common.high": "Alto",
  "common.home": "Casa",
  "common.homeConnectService": "¿Tienes una estación meteorológica? Conecta tu servicio",
  "common.homeInformation": "Información de la casa",
  "common.homeIntroduction": "Comience a conectar sus cuentas externas para disfrutar de las funciones de SmartMixin.",
  "common.homeName": "Nombre de la casa",
  "common.homeSubtitle": "Tu clima, todo en un solo lugar",
  "common.horizon": "Horizonte",
  "common.horizonValue": "hasta {value} horas",
  "common.iDontKnowYet": "Aún no lo sé",
  "common.indoor": "Interior",
  "common.lastRainEvent": "último evento de lluvia",
  "common.lastUpdate": "Última actualización",
  "common.legendHeavy": "Fuerte",
  "common.legendLight": "Ligera",
  "common.legendLightningHelp": "El color muestra la antigüedad de cada rayo en los últimos {minutes} minutos: los más recientes en blanco y los más antiguos en rojo oscuro.",
  "common.legendNewest": "Más recientes",
  "common.legendOldest": "Más antiguos",
  "common.legendStationsHelp": "El color del marcador refleja el valor de la métrica seleccionada.",
  "common.lightningDataAttribution": "Datos de rayos: Blitzortung.org",
  "common.lightningStrikes": "Rayos",
  "common.lightningStrikesDescription": "Mostrar rayos en tiempo real en el mapa",
  "common.loading": "Cargando",
  "common.location": "Lugar",
  "common.locationAddedToFavorites": "Ubicación agregada a favoritos",
  "common.locationNotGranted": "El permiso de ubicación no se otorga. Permita el acceso a su ubicación en la configuración del dispositivo.",
  "common.locationRemovedFromFavorites": "Ubicación eliminada de favoritos",
  "common.locations": "Lugares",
  "common.low": "Bajo",
  "common.manage": "Administrar",
  "common.manageAccount": "Administrar cuenta",
  "common.manageMySubscription": "Administrar mi suscripción",
  "common.manageSensors": "Gestionar sensores",
  "common.manageSensorsDescription": "Arrastra elementos para reordenar los sensores. Toca el icono del ojo para mostrar u ocultar sensores. Toca un nombre para renombrarlo.",
  "common.manualBoost": "Manual boost",
  "common.manualSetpointUntil": "Consigna manual hasta",
  "common.mapLayers": "Capas del mapa",
  "common.mapLegend": "Leyenda del mapa",
  "common.maxFavoriteLocationsReached": "Solo puedes tener hasta 5 ubicaciones favoritas. Retire uno para agregar otro.",
  "common.measureToDisplay": "Medidas para mostrar",
  "common.medium": "Medio",
  "common.meshSize": "Tamaño de cuadrícula",
  "common.minRead": "{minutes} min de lectura",
  "common.modifyFavoriteStations": "Modificar las estaciones favoritas",
  "common.modifyFavoriteStationsDescription": "Puede reordenar sus estaciones favoritas arrastrándolas. También puede eliminarlos de la lista.",
  "common.moduleType": "Tipo de módulo",
  "common.monthTotal": "Mes en total",
  "common.more": "Más",
  "common.moreInformation": "Más información",
  "common.myLocation": "Mi ubicación",
  "common.nearbyWeatherStations": "Estaciones meteorológicas cercanas",
  "common.next": "Próximo",
  "common.nextHours": "próximas horas",
  "common.no": "No",
  "common.noAccountNeeded": "No se necesita cuenta",
  "common.noDataForThisPeriod": "No hay datos para este período",
  "common.noLocationsFound": "No se encontraron ubicaciones",
  "common.noNetatmoWeatherStationYet": "Usted no tiene una estación meteorológica Netatmo",
  "common.noOutdoorModule": "No hay ningún módulo exterior en funcionamiento para esta estación.",
  "common.noStationsFound": "No se encontraron estaciones",
  "common.noThermostatYet": "Usted no tiene un termostato Netatmo",
  "common.notNow": "Ahora no",
  "common.notPurchasedYet": "Parece que esto no ha sido comprado todavía.",
  "common.noWeatherStation": "Sin estación meteorológica",
  "common.noWeatherStationYet": "Usted no tiene una estación meteorológica.",
  "common.numberOfActiveWarnings": "{warning_count} advertencias meteorológicas activas",
  "common.openSettings": "Abrir configuración",
  "common.orChooseMonthly": "O elegir mensual:",
  "common.outdatedModule": "Los datos de este módulo no están actualizados.",
  "common.outdoor": "Exterior",
  "common.outdoorTemperature": "Temperatura exterior",
  "common.pageNotFound": "Página No Encontrada",
  "common.pageNotFoundDescription": "La página que buscas no existe o ha sido movida.",
  "common.passwordUpdated": "Contraseña actualizada correctamente.",
  "common.personalWeatherIntelligence": "Tu Inteligencia Meteorológica Personal",
  "common.premiumAccount": "Cuenta Premium",
  "common.premiumDescription": "La suscripción premium desbloquea una gran variedad de funciones adicionales como análisis meteorológico avanzado, comparación de gráficos, modelos de pronóstico regional y mucho más",
  "common.premiumFeatureAlerts": "Alertas Meteorológicas",
  "common.premiumFeatureAnalysis": "Análisis Meteorológico Avanzado",
  "common.premiumFeatureCharts": "Comparaciones de Gráficos",
  "common.premiumFeatureExport": "Exportación de Datos",
  "common.premiumFeatureForecast": "Modelos de Pronóstico Regional",
  "common.premiumFeatureNotification": "Widget de Barra de Estado",
  "common.premiumFeatureTitle": "Función Premium",
  "common.premiumFeatureWidgets": "Widgets de pantalla de inicio",
  "common.pressureSummary": "Resumen de presión",
  "common.previous": "Anterior",
  "common.previousHours": "Horas anteriores",
  "common.profileUpdated": "Perfil actualizado correctamente.",
  "common.purchasedNetatmoPro": "Ya has comprado Netatmo Pro ({date}). Te da acceso a las funciones Premium. Suscríbete a una de las siguientes ofertas si quieres acceder a todas las funciones Premium.",
  "common.radarDataAttribution": "Datos de radar: RainViewer.com",
  "common.rain": "Lluvia",
  "common.rainEvents": "Eventos de lluvia",
  "common.rainfallMeasurement": "Medición de precipitaciones",
  "common.rainRadar": "Radar de lluvia",
  "common.rainRadarDescription": "Mostrar superposición de radar de lluvia en el mapa",
  "common.rainSummary": "Resumen de lluvia",
  "common.range": "Amplitud",
  "common.recentLocations": "Reciente",
  "common.recentLocationsEmpty": "Tu historia reciente está vacía.",
  "common.recentStations": "Estaciones recientes",
  "common.relatedArticles": "Artículos relacionados",
  "common.relay": "Relé",
  "common.removeFromFavorites": "Quitar de favoritos",
  "common.renameSensors": "Renombrar sensores",
  "common.resetZoom": "Restablecer zoom",
  "common.restorePurchase": "Restaurar la compra",
  "common.room": "Habitación",
  "common.rooms": "Habitaciones",
  "common.savingsPercent": "Ahorra {percent}%",
  "common.searchArticles": "Buscar artículos...",
  "common.searchForALocation": "Buscar una ubicación...",
  "common.searchForLocation": "Buscar un lugar",
  "common.searchForWeatherStation": "Buscar una estación meteorológica",
  "common.searchResults": "Resultados de la búsqueda",
  "common.searchResultsEmpty": "No se encontraron resultados.",
  "common.searchStationsDescription": "Ingresa una ciudad, dirección o nombre de lugar para encontrar estaciones meteorológicas cercanas.",
  "common.searchStationsHint": "Usa la barra de búsqueda de arriba para descubrir estaciones meteorológicas en cualquier lugar del mundo.",
  "common.selectStationForComparison": "Seleccione una estación para comparar",
  "common.selectWeatherForecastProvider": "Elija un proveedor meteorológico",
  "common.serialNumber": "Número de serie",
  "common.share": "Compartir",
  "common.shareOutdoorMeasures": "Comparte tus medidas exteriores",
  "common.shareOutdoorMeasuresDescription": "Únase a la comunidad SmartMixin haciendo que sus mediciones al aire libre sean visibles para los demás. Las medidas en interiores no se compartirán.",
  "common.shareYourWeather": "Comparte tu clima",
  "common.signalStrength": "Intensidad de la señal",
  "common.skip": "Saltar",
  "common.smartThermostat": "Termostato inteligente",
  "common.smartValve": "Válvula inteligente",
  "common.snow": "Nieve",
  "common.start": "Comenzar",
  "common.startFreeTrial": "Iniciar Prueba Gratuita",
  "common.startTime": "Hora de inicio",
  "common.station": "estación",
  "common.stationAddedToFavorites": "Emisora añadida a favoritos",
  "common.stationComparison": "Comparación de estaciones",
  "common.stationComparisonDescription": "Compara datos meteorológicos históricos con otra estación",
  "common.stationInformation": "Información de la estación",
  "common.stationName": "Nombre de la estación",
  "common.stationObservationsDescription": "Mostrar las últimas observaciones de las estaciones meteorológicas.",
  "common.stationRemovedFromFavorites": "Estación eliminada de favoritos",
  "common.stations": "estaciones",
  "common.stationsNear": "Estaciones cerca de",
  "common.stationType": "Tipo de estación",
  "common.statusOffline": "Sin conexión",
  "common.statusOnline": "En línea",
  "common.statusStale": "Desactualizado",
  "common.statusSyncing": "Sincronizando",
  "common.subscribeNow": "Suscribirse ahora - sin prueba",
  "common.sumOverThePeriod": "Acumulado durante el período",
  "common.switchToPremium": "Cambiar a SmartMixin Premium",
  "common.temperatureShort": "Temp.",
  "common.temperatureSummary": "Resumen de temperatura",
  "common.thankYouForFeedback": "¡Gracias por tu opinión!",
  "common.thenPrice": "luego {price}",
  "common.timeSelection": "Selección de hora",
  "common.timezone": "Huso horario",
  "common.totalDuration": "Duración total",
  "common.tryAnotherLocation": "No pudimos encontrar estaciones meteorológicas cerca de esta ubicación. Intenta buscar en otra zona.",
  "common.unknown": "Desconocido",
  "common.untilChanged": "Hasta que se modifique",
  "common.untilTime": "Hasta las {time}",
  "common.upgrade": "Actualizar",
  "common.upgradeRequiredAndroid": "Se requiere una actualización de su aplicación, vaya a Google Play para actualizar.",
  "common.upgradeRequiredIos": "Se requiere una actualización de su aplicación, vaya a la tienda de aplicaciones para actualizar.",
  "common.validate": "Validar",
  "common.validEmail": "Se requiere una dirección de correo electrónico válida.",
  "common.very_low": "Muy bajo",
  "common.visitNetatmoWebsite": "Sitio web Netatmo",
  "common.wasArticleHelpful": "¿Te resultó útil este artículo?",
  "common.weatherCondition": "Condición meteorológica",
  "common.weatherflowNCRain": "NC rain (Nearcast rain)",
  "common.weatherflowNCRainDescription": "NC Rain es una fuente de datos adicional proporcionada a través del Tempest Weather System, impulsado por Nearcast Technology. Los datos de NC Rain son una estimación de la acumulación promedio de lluvia alrededor de Tempest a nivel de vecindario.",
  "common.weatherForecastModels": "Modelos de pronóstico del tiempo",
  "common.weatherIntelligencePlatform": "La Plataforma de Inteligencia Meteorológica",
  "common.weatherMap": "Mapa climático",
  "common.weatherMapMetaDescription": "SmartMixin ofrece mapas meteorológicos interactivos y radares de lluvia para las condiciones climáticas en todo el mundo.",
  "common.weatherObservations": "Observaciones meteorológicas",
  "common.weatherStation": "Estación meteorológica",
  "common.weatherStations": "Estaciones meteorológicas",
  "common.welcome": "¡Bienvenido a SmartMixin!",
  "common.whenBackHome": "¿Cuándo volverás a casa?",
  "common.wifiStrength": "Potencia de WiFi",
  "common.wind": "Viento",
  "common.windMeasurement": "Medida de viento",
  "common.windSpeed": "Velocidad del viento",
  "common.windSummary": "Resumen de viento",
  "common.yearToDate": "El año hasta la fecha",
  "common.yes": "Sí",
  "intro.locationDescription": "Permite el acceso a tu ubicación para recibir predicciones meteorológicas precisas adaptadas a tu área exacta — sin pronósticos genéricos.",
  "intro.locationTitle": "Pronósticos hechos para ti",
  "intro.notificationDescription": "Activa las notificaciones para recibir alertas oportunas sobre cambios climáticos que te importan — lluvia, nieve o condiciones severas, justo cuando lo necesitas.",
  "intro.notificationsTitle": "No te pierdas ningún cambio climático",
  "intro.readyDescription": "Disfruta de pronósticos precisos, información meteorológica en tiempo real y datos de estaciones de todo el mundo — todo en una aplicación potente.",
  "intro.readyTitle": "¡Todo listo!",
  "intro.welcomeDescription": "Obtén pronósticos hiperlocales de las principales agencias meteorológicas — más acceso a más de 40.000 estaciones meteorológicas en todo el mundo para ver las condiciones reales, presentes y pasadas.",
  "intro.welcomeTitle": "Tu pronóstico reinventado",
  "landing.alerts": "Alertas",
  "landing.alertsDescription": "Cree sus propias alertas y reciba notificaciones tan pronto como se activen.",
  "landing.featureAlertsDescription": "Establece umbrales personalizados para cualquier métrica. Recibe notificaciones cuando la temperatura baje, comience a llover o sople el viento.",
  "landing.featureAlertsTitle": "Alertas inteligentes",
  "landing.featureAnalyticsDescription": "Gráficos interactivos, análisis de tendencias y estadísticas detalladas. Profundiza en datos de temperatura, humedad, presión, lluvia y viento.",
  "landing.featureAnalyticsTitle": "Análisis avanzados",
  "landing.featureExportDescription": "Descarga tus datos meteorológicos como archivos CSV para análisis adicional en Excel, Google Sheets o tus herramientas favoritas.",
  "landing.featureExportTitle": "Exporta tus datos",
  "landing.featureForecastDescription": "Accede a más de 10 modelos de pronóstico profesionales incluyendo ECMWF, GFS y modelos regionales. Compáralos lado a lado para hacer tus propias predicciones.",
  "landing.featureForecastTitle": "Compara modelos de pronóstico",
  "landing.featureHistoryDescription": "Accede a datos históricos con escala horaria, diaria y mensual. Exporta a CSV para investigación o archivos personales.",
  "landing.featureHistoryTitle": "Historial completo",
  "landing.featureMultiBrandDescription": "Conecta Netatmo, Davis, Tempest, Ecowitt, Ambient Weather y más. No más cambiar entre aplicaciones.",
  "landing.featureMultiBrandTitle": "Todas las marcas, una app",
  "landing.featuresSubtitle": "SmartMixin te da las herramientas para analizar, comparar y entender tus datos meteorológicos como un profesional.",
  "landing.featuresTitle": "Diseñado para amantes de los datos",
  "landing.finalCtaButton": "Crear cuenta gratuita",
  "landing.finalCtaSubtitle": "Únete a miles de entusiastas del clima que confían en SmartMixin.",
  "landing.finalCtaTitle": "¿Listo para profundizar en tus datos meteorológicos?",
  "landing.forecastDescription": "Acceda a algunos de los mejores modelos de pronóstico del tiempo y compárelos para tener su propia idea de cómo estará el tiempo.",
  "landing.forecasts": "Previsiones",
  "landing.heroCta": "Empezar gratis",
  "landing.heroDescription": "Análisis profundos, gráficos hermosos y pronósticos profesionales — todas tus estaciones meteorológicas unificadas en una potente aplicación.",
  "landing.heroSecondaryCta": "Explorar el mapa",
  "landing.heroTagline": "Para entusiastas del clima",
  "landing.heroTitle": "Ve tu clima como nunca antes",
  "landing.pricingFeatureAdvancedMetrics": "Métricas avanzadas",
  "landing.pricingFeatureAlerts": "Alertas personalizadas",
  "landing.pricingFeatureExport": "Exportación de datos (CSV)",
  "landing.pricingFeatureForecastComparison": "Comparación de pronósticos",
  "landing.pricingFeatureForecasts": "Modelos de pronóstico",
  "landing.pricingFeatureForecastsFreeTier": "1 modelo",
  "landing.pricingFeatureForecastsPremiumTier": "10+ modelos",
  "landing.pricingFeatureReports": "Análisis e informes",
  "landing.pricingFeatureStationComparison": "Comparación de estaciones",
  "landing.pricingFeatureWidgets": "Widgets de pantalla de inicio",
  "landing.pricingFeatureYearOverYear": "Análisis interanual",
  "landing.pricingFree": "Gratis",
  "landing.pricingFreeCta": "Empezar",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Más popular",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Empezar",
  "landing.pricingPremiumDescription": "Desde 1,99 €/mes — suscríbete en la web, App Store o Google Play",
  "landing.pricingSubtitle": "Empieza gratis, mejora cuando necesites más potencia.",
  "landing.pricingTitle": "Precios simples y transparentes",
  "landing.smartMixinDescription": "SmartMixin es una aplicación que proporciona acceso a su estación meteorológica y a más de 40.000 estaciones en todo el mundo. Le ayuda a ver y comprender los datos meteorológicos.",
  "landing.statBrands": "Marcas compatibles",
  "landing.statForecasts": "Modelos de pronóstico",
  "landing.statStations": "Estaciones meteorológicas",
  "landing.supportedDevices": "Dispositivos soportados",
  "landing.supportedDevicesDescription": "Además de las estaciones de la Organización Meteorológica Mundial, SmartMixin admite un número creciente de marcas de estaciones meteorológicas.",
  "landing.supportedDevicesNote": "Más de 40,000 estaciones públicas de la Organización Meteorológica Mundial",
  "landing.supportedDevicesSubtitle": "Conecta tu estación meteorológica existente en minutos. Soportamos 8 marcas principales y más.",
  "landing.supportedDevicesTitle": "Funciona con tu estación",
  "landing.thermostatDescription": "Conecta tu termostato Netatmo para correlacionar patrones de calefacción con condiciones exteriores.",
  "landing.thermostatManufacturers": "También se ayuda a los fabricantes de termostatos a correlacionar la calefacción con las condiciones exteriores.",
  "landing.thermostatTitle": "Integración de hogar inteligente",
  "landing.weatherAnalysis": "Análisis del tiempo",
  "landing.weatherAnalysisDescription": "SmartMix viene con una gran cantidad de visualización de datos que le permite analizar datos meteorológicos.",
  "landing.weatherAssistant": "Tu asistente meteorológico",
  "landing.weatherAssistantDescription": "Ya sea que esté interesado en las condiciones climáticas actuales, históricas o pronosticadas, SmartMixin le brinda numerosos conocimientos siempre que los necesite.",
  "landing.weatherForecastModels": "Modelos de pronóstico del tiempo",
  "landing.weatherForecastModelsDescription": "SmartMixin brinda acceso a los modelos de pronóstico del tiempo más precisos. Puede comparar fácilmente sus pronósticos y crear su propia idea.",
  "landing.weatherMap": "Mapa climático",
  "landing.weatherMapDescription": "Explora el mapa y visualiza cómo es el clima en cualquier parte del mundo.",
  "network.cancelError": "Solicitud cancelada",
  "network.connectionError": "No se puede conectar al servidor",
  "network.networkError": "Red non disponible",
  "network.serverError": "Ha sucedido un problema...",
  "network.timeoutError": "El tiempo de conexión ha expirado",
  "network.unknownError": "Error desconocido",
  "providerHints.ambientWeatherApiKey": "Creada en los ajustes de su cuenta de ambientweather.net.",
  "providerHints.davisApiSecret": "Se muestra solo una vez al crear la clave API V2 — guárdelo bien.",
  "providerHints.davisV2ApiKey": "Desde la página de claves API V2 en weatherlink.com.",
  "providerHints.ecowittApi": "Desde la página API de su cuenta Ecowitt.",
  "providerHints.ecowittApp": "La clave de aplicación, también desde su cuenta Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Use el correo y la contraseña de su cuenta My AcuRite — no el acceso de SmartMixin.",
  "providerHints.myAcuriteEmail": "El correo electrónico de su cuenta My AcuRite — no su acceso de SmartMixin.",
  "providerHints.myAcuritePassword": "La contraseña de su cuenta My AcuRite.",
  "providerHints.weatherflowToken": "Token de uso personal desde tempestwx.com → ajustes → autorizaciones de datos.",
  "providerHints.wundergroundEditKey": "Usar otra clave",
  "providerHints.wundergroundKey": "Una cadena larga de la página de claves API de su cuenta Weather Underground — no su contraseña de wunderground.com.",
  "providerHints.wundergroundKeyExample": "ej. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "Clave API verificada",
  "providerHints.wundergroundKeyVerifying": "Verificando clave…",
  "providerHints.wundergroundNoStationsNearby": "No se encontraron estaciones cerca de esta ubicación. Pruebe a introducir un ID de estación directamente.",
  "providerHints.wundergroundStationId": "Cualquier ID de estación de Weather Underground — la suya o una estación pública cercana.",
  "providerHints.wundergroundStationIdExample": "ej. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Obtenga su clave API de Ambient Weather.",
  "providerIntro.davisStep2": "Obtenga su clave API V2 y secreto API de Davis.",
  "providerIntro.ecowittStep2": "Obtenga su clave API y clave de aplicación de Ecowitt.",
  "providerIntro.getStarted": "Comenzar",
  "providerIntro.myAcuriteStep2": "Use el correo y la contraseña de su cuenta de My AcuRite existente.",
  "providerIntro.netatmoEnergyStep2": "Inicie sesión en Netatmo cuando se le solicite — no se necesita clave API.",
  "providerIntro.netatmoWeatherStep2": "Inicie sesión en Netatmo cuando se le solicite — no se necesita clave API.",
  "providerIntro.signupBanner": "Ya casi — cree su cuenta gratuita de SmartMixin para conectar {provider}.",
  "providerIntro.step1": "Inicie sesión en su cuenta de SmartMixin (NO en {provider}).",
  "providerIntro.step3EmailPassword": "Introdúzcalos aquí.",
  "providerIntro.step3KeyOrToken": "Péguelo aquí.",
  "providerIntro.step3OAuth": "Autorice SmartMixin en la ventana emergente.",
  "providerIntro.step3Wunderground": "Pegue su clave API y luego seleccione una estación cercana o introduzca cualquier ID de estación.",
  "providerIntro.title": "Conectar {provider}",
  "providerIntro.weatherflowStep2": "Obtenga su token de uso personal de Tempest.",
  "providerIntro.wundergroundBrowsePublic": "¿No tiene estación? Explore las públicas",
  "providerIntro.wundergroundFindNearby": "Buscar estaciones cercanas",
  "providerIntro.wundergroundOrEnterId": "O introducir un ID de estación",
  "providerIntro.wundergroundStep2": "Obtenga su clave API de Weather Underground. Después podrá conectar cualquier estación — la suya o una pública.",
  "reports.agroMeteorology": "Agrometeorología",
  "reports.analysis": "Análisis",
  "reports.annualCumulativeRainfallComparison": "Comparación de precipitaciones anuales",
  "reports.annualHeatingDurationComparison": "Comparación de la duración del calentamiento anual",
  "reports.annualHeatingEfficiency": "Eficiencia anual de calefacción",
  "reports.annualIndoorComparison": "Comparación anual de interior",
  "reports.annualIndoorReport": "Reporte anual de interior",
  "reports.annualOutdoorComparison": "Comparación anual de exterior",
  "reports.annualOutdoorReport": "Reporte anual de exterior",
  "reports.annualReport": "Reporte anual",
  "reports.annualSolarReport": "Informe solar anual",
  "reports.annualWaterBalance": "Balance hídrico anual",
  "reports.annualWaterBalanceCarryOver": "Trasladar del año anterior",
  "reports.annualWaterBalanceDescription": "El balance hídrico (versión simplificada, solo se utilizan la lluvia y la evapotranspiración) ayuda a gestionar el suministro de agua",
  "reports.avgHumidity": "Humedad Promedia",
  "reports.avgMaxTemperature": "Promedia T°max",
  "reports.avgMinTemperature": "Promedia T°min",
  "reports.avgPressure": "Presión Promedia",
  "reports.avgTemperature": "Temperatura Promedia",
  "reports.comfortable": "Confortable (45% {lessThan} Humedad ≤ 60%)",
  "reports.cumulativeRainfall": "Precipitación acumulada",
  "reports.cumulativeRainfallDescription": "Realiza un seguimiento de la precipitación total acumulada durante el período seleccionado.",
  "reports.dailyMaxRainfall": "Máxima Diaria",
  "reports.dataExport": "Exportación de datos",
  "reports.dataExportXlsxFormatDescription": "Exporte todos los datos de su estación en formato Excel (* .xlsx). Una vez que haga clic en el botón, recibirá un correo electrónico con los datos procesados después de unos minutos.",
  "reports.daysWithFrost": "Días con Heladas",
  "reports.daysWithoutThaw": "Días sin deshielo",
  "reports.daysWithStrongFrost": "Días con Heladas Fuertes",
  "reports.emailSent": "Se te ha enviado un correo electrónico",
  "reports.grasslandTemperatureSum": "Temperatura total en hierba",
  "reports.grasslandTemperatureSumDescription": "Cuando se supera la suma {threshold} en primavera, se ha logrado el inicio sostenible de la vegetación/agricultura (obras para Europa)",
  "reports.growingDegreeDays": "Grados día de crecimiento",
  "reports.highPressure": "Anticiclón (Presión Prom ≥ 1013 mbar)",
  "reports.indoorReport": "Reporte de interior",
  "reports.keyFacts": "Datos Clave",
  "reports.longestRunOfRainyDays": "Período más largo de días lluviosos",
  "reports.longestRunWithoutRun": "Período más largo sin lluvia",
  "reports.lowPressure": "Baja Presión (Presión Prom < 1013 mbar)",
  "reports.maxHumidity": "Humedad Máxima",
  "reports.maxPressure": "Presión Máxima",
  "reports.maxPressureMagnitude24h": "Magnitud Máxima (/24H)",
  "reports.maxTemperature": "Temperatura Máxima",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Magnitud Máxima (/24H)",
  "reports.minHumidity": "Humedad Mínima",
  "reports.minPressure": "Presión Mínima",
  "reports.minPressureMagnitude24h": "Magnitud Mínima (/ 24H)",
  "reports.minTemperature": "Temperatura Mínim",
  "reports.minTempMagnitude24h": "Magnitud Mínima (/ 24H)",
  "reports.monthlyHeatingEfficiency": "Eficiencia de calefacción mensual",
  "reports.monthlyIndoorReport": "Reporte mensual de interior",
  "reports.monthlyOutdoorReport": "Reporte mensual de exterior",
  "reports.monthlyReport": "Reporte mensual",
  "reports.monthlySolarReport": "Informe solar mensual",
  "reports.monthlyWindReport": "Reporte mensual de viento",
  "reports.numberOfDays": "Número de Días",
  "reports.outdoorReport": "Reporte de exterior",
  "reports.rainfall": "Precipitación",
  "reports.rainyDays": "Días Lluviosos",
  "reports.relativelyWet": "Relativamente húmedo (60 % < Humedad ≤ 80 %)",
  "reports.sendEmail": "Enviar correo electrónico",
  "reports.tooDry": "Demasiado seco (Humedad ≤ 45%)",
  "reports.tooWet": "Demasiado húmedo (Humedad {greaterThan} 80%)",
  "reports.tropicalNights": "Noches Tropicales",
  "reports.waterBalance": "Balance de agua",
  "reports.yearToDateTemperature": "Temperatura del año hasta la fecha",
  "reports.yearToDateTemperatureComparison": "Comparación de temperatura del año hasta la fecha",
  "sensors.aqiByChannel": "AQI por canal",
  "sensors.bgtSensors": "Globo negro y WBGT",
  "sensors.cameraFeed": "Cámara",
  "sensors.compareAqi": "Comparar AQI",
  "sensors.compareHumidity": "Comparar humedad",
  "sensors.compareMoisture": "Comparar humedad del suelo",
  "sensors.comparePm25": "Comparar PM2.5",
  "sensors.compareTemperatures": "Comparar temperaturas",
  "sensors.depthByChannel": "Profundidad por canal",
  "sensors.heatStressExtreme": "Estrés térmico extremo",
  "sensors.heatStressModerate": "Estrés térmico moderado",
  "sensors.heatStressNone": "Sin estrés térmico",
  "sensors.heatStressStrong": "Estrés térmico fuerte",
  "sensors.heatStressVeryStrong": "Estrés térmico muy fuerte",
  "sensors.humidityByChannel": "Humedad por canal",
  "sensors.indoorAirQuality": "Calidad del aire interior",
  "sensors.indoorAirQualityPm": "PM2.5 y PM10 AQI",
  "sensors.indoorClimate": "Clima interior",
  "sensors.indoorCo2Levels": "Niveles de CO2",
  "sensors.indoorTemperatureAndHumidity": "Temperatura y humedad",
  "sensors.last24Hours": "24 horas",
  "sensors.last30Days": "30 días",
  "sensors.last7Days": "7 días",
  "sensors.leafTemperatureByChannel": "Temperatura de las hojas por canal",
  "sensors.leafWetnessByChannel": "Humedad de las hojas por canal",
  "sensors.lightningSensor": "Rayo",
  "sensors.moistureByChannel": "Humedad del suelo por canal",
  "sensors.noDataAvailable": "No hay datos disponibles",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 por canal",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Seleccionar canal",
  "sensors.sensorDetailDescription": "Ver datos históricos y tendencias de los canales del sensor.",
  "sensors.sensorHistory": "Historial del sensor",
  "sensors.soilConductivityByChannel": "Conductividad por canal",
  "sensors.soilTemperatureByChannel": "Temperatura del suelo por canal",
  "sensors.strikesToday": "Impactos hoy",
  "sensors.temperatureByChannel": "Temperatura por canal",
  "settings.about": "Acerca de",
  "settings.aboutDescription": "Acuerdo de licencia, política de privacidad",
  "settings.account": "Cuenta",
  "settings.accountDescription": "Perfil, cambio de contraseña",
  "settings.accountIntro": "Los datos se refieren a su cuenta:",
  "settings.accountSection": "Cuenta",
  "settings.appearance": "Apariencia",
  "settings.appearanceDescription": "Tema y opciones de visualización",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "Árabe",
  "settings.availableServices": "Disponibles",
  "settings.bulgarian": "Búlgaro",
  "settings.cannotDisconnectLastAccount": "No se puede desconectar su único método de inicio de sesión. Por favor, añada primero otro método de inicio de sesión.",
  "settings.changeEmail": "Cambiar correo electrónico",
  "settings.changePassword": "Cambiar contraseña",
  "settings.chartGestures": "Gestos en gráficos",
  "settings.chartGesturesDescription": "Deslizar el dedo en los gráficos cambia el período de tiempo, pellizcar los gráficos cambia la escala de tiempo",
  "settings.connect": "Conectar",
  "settings.connected": "Conectado",
  "settings.connectedAccounts": "Cuentas conectadas",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Conectados",
  "settings.connectedSince": "Conectado desde {date}",
  "settings.connectionSuccess": "Cuenta de {provider} conectada correctamente",
  "settings.contactUs": "Contáctanos",
  "settings.contactUsDescription": "Obtén ayuda o envía comentarios",
  "settings.croatian": "Croata",
  "settings.currentPassword": "Contraseña actual",
  "settings.czech": "Checo",
  "settings.danish": "danés",
  "settings.dark": "Tema oscuro",
  "settings.dataDisplay": "Visualización de datos",
  "settings.dateAndTime": "Fecha y hora",
  "settings.disconnect": "Desconectar",
  "settings.disconnectConfirmation": "¿Está seguro de que desea desconectar su cuenta de {provider}?",
  "settings.disconnectionSuccess": "Cuenta de {provider} desconectada correctamente",
  "settings.donateButton": "Hacer una donación",
  "settings.donateDescription": "SmartMixin está desarrollado por un equipo pequeño. Si le resulta útil, puede apoyar su desarrollo con una donación única de cualquier importe. Es un regalo — no cambia su plan ni desbloquea ninguna función.",
  "settings.donateSuccessBody": "Su donación ayuda a mantener SmartMixin en funcionamiento y a mejorarlo. Se lo agradecemos de verdad.",
  "settings.donateSuccessTitle": "¡Gracias por su apoyo!",
  "settings.donateTitle": "Apoye a SmartMixin",
  "settings.dutch": "Holandés",
  "settings.emailChange": "Cambiar dirección de correo electrónico",
  "settings.emailChangeConfirmation": "Confirmación de cambio de correo electrónico",
  "settings.emailChangeFailure": "El enlace de cambio de correo electrónico es inválido o ha expirado.",
  "settings.emailChangeSuccess": "Su correo electrónico ha sido cambiado exitosamente a {newEmail}.",
  "settings.emailChangeVerificationSent": "Se ha enviado un correo de verificación a su nueva dirección de correo electrónico. Por favor, revise su bandeja de entrada y haga clic en el enlace para confirmar el cambio.",
  "settings.english": "Inglés",
  "settings.forecastModelOrderEmpty": "No hay orden guardado — usamos GFS de forma predeterminada.",
  "settings.forecastModelOrderFreeHint": "Los modelos premium requieren una suscripción a SmartMixin Premium.",
  "settings.forecastModelOrderHelp": "Elegimos el primer modelo de tu lista que cubra cada estación.",
  "settings.forecastModelOrderReset": "Restablecer",
  "settings.forecastModelOrderTitle": "Modelo de previsión predeterminado",
  "settings.forecastModels": "Modelos de previsión",
  "settings.forecastModelsDescription": "Reordenar por preferencia",
  "settings.french": "francés",
  "settings.german": "Alemán",
  "settings.gestures": "Gestos",
  "settings.greek": "Griego",
  "settings.helpCenter": "Centro de ayuda",
  "settings.helpCenterDescription": "Preguntas frecuentes y guías",
  "settings.hungarian": "Húngaro",
  "settings.integrationsSection": "Integraciones",
  "settings.italian": "italiano",
  "settings.japanese": "japonés",
  "settings.korean": "coreano",
  "settings.language": "Idioma",
  "settings.languageDescription": "Idioma preferido",
  "settings.light": "Tema de luz",
  "settings.newEmailAddress": "Nueva dirección de correo electrónico",
  "settings.newPassword": "Nueva contraseña",
  "settings.newPasswordAgain": "Nueva contraseña (de nuevo)",
  "settings.norwegian": "Noruego",
  "settings.notConnected": "No conectado",
  "settings.notificationsSection": "Notificaciones",
  "settings.oldPassword": "Contraseña antigua",
  "settings.ongoingNotificationEnabled": "Activar notificación permanente",
  "settings.ongoingNotificationMetrics": "Métricas mostradas",
  "settings.ongoingNotificationMetricsHint": "Arrastra para reordenar las métricas seleccionadas",
  "settings.ongoingNotificationPermissionRequired": "Se requiere permiso de notificación",
  "settings.ongoingNotificationStation": "Estación meteorológica",
  "settings.passwordChange": "Cambio de contraseña",
  "settings.polish": "Polaco",
  "settings.portuguese": "Portugués",
  "settings.preferencesSection": "Preferencias",
  "settings.premium": "Premium",
  "settings.premiumActive": "Activo",
  "settings.premiumAnnualThenPrice": "Luego 9,99 €/año",
  "settings.premiumAnnualTrialInfo": "Comienza con una prueba gratuita de {days} días",
  "settings.premiumCurrentPlan": "Plan actual",
  "settings.premiumDescription": "Desbloquear funciones premium",
  "settings.premiumDownloadApp": "Descarga la aplicación para suscribirte:",
  "settings.premiumExpiresOn": "Se renueva el {date}",
  "settings.premiumFreePlan": "Gratuito",
  "settings.premiumInactive": "No suscrito",
  "settings.premiumManageWebSubscription": "Gestiona tu suscripción, actualiza el método de pago o cancela.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Anual — 9,99 €/año",
  "settings.premiumSubscribedOn": "Suscrito en {platform}",
  "settings.premiumSubscribeMonthly": "Mensual — 1,99 €/mes",
  "settings.premiumSubscribeOnWeb": "Suscríbete ahora para desbloquear todas las funciones premium.",
  "settings.premiumSubscriptionSuccess": "¡Tu suscripción ha sido activada! Disfruta de todas las funciones premium.",
  "settings.premiumSubscriptionSuccessTitle": "¡Bienvenido a Premium!",
  "settings.premiumWebappNotice": "Las suscripciones solo se pueden comprar a través de la aplicación móvil SmartMixin en iOS o Android.",
  "settings.privacyPolicy": "Política de privacidad",
  "settings.profile": "Perfil",
  "settings.russian": "ruso",
  "settings.serbian": "Serbio",
  "settings.settings": "Configuración",
  "settings.slovak": "Eslovaco",
  "settings.smallDecimals": "Decimales pequeños",
  "settings.smallDecimalsDescription": "Mostrar dígitos decimales en un tamaño más pequeño",
  "settings.socialConnectionsIntro": "Vincule sus cuentas sociales para iniciar sesión rápidamente. Puede conectar o desconectar cuentas en cualquier momento.",
  "settings.spanish": "Español",
  "settings.statusBarWidget": "Widget de barra de estado",
  "settings.statusBarWidgetDescription": "Datos meteorológicos siempre visibles",
  "settings.subscriptionSection": "Suscripción",
  "settings.supportSection": "Soporte",
  "settings.swedish": "Sueco",
  "settings.systemTheme": "Tema del sistema",
  "settings.termsOfService": "Términos de servicio",
  "settings.turkish": "turco",
  "settings.ukrainian": "ucranio",
  "settings.units": "Unidades",
  "settings.unitsDescription": "Unidades de medida mostradas dentro de la aplicación",
  "settings.update": "Poner al día",
  "settings.updateYourProfile": "Actualiza tu perfil",
  "settings.weatherServices": "Servicios meteorológicos",
  "settings.weatherServicesConnected": "{count, plural, =0 {Ningún servicio conectado} one {# servicio conectado} other {# servicios conectados}}",
  "settings.weatherServicesDescription": "Conecta Netatmo, Davis, Weatherflow y más",
  "settings.windDirectionConvention": "Flecha de dirección del viento",
  "settings.windDirectionConventionDescription": "Elige cómo se muestran las flechas de dirección del viento",
  "settings.windDirectionMeteorological": "Dirección de origen",
  "settings.windDirectionMeteorologicalDescription": "La flecha indica de dónde viene el viento (convención meteorological)",
  "settings.windDirectionOceanographic": "Dirección de flujo",
  "settings.windDirectionOceanographicDescription": "La flecha indica hacia dónde sopla el viento (convención oceanographic)",
  "units.absolutePressure": "Presión absoluta",
  "units.airDensity": "Hermeticidad",
  "units.airGap": "Espacio de aire",
  "units.apparentTemperature": "Temperatura aparente",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Prom.",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Temp. globo negro",
  "units.boilerOn": "Calentador encendido",
  "units.co2": "CO2",
  "units.conductivity": "Conductividad",
  "units.coolingDegreeDays": "Grados día de refrigeración",
  "units.dailyHeatingDuration": "Duración diaria de la calefacción",
  "units.dailyPrecipitation": "Precipitación diaria",
  "units.dailyRain": "Lluvia diaria",
  "units.degreeDay": "día de grado",
  "units.degreeDayShort": "DD",
  "units.depth": "Profundidad",
  "units.depthSensors": "Sensores de profundidad",
  "units.dewPoint": "Punto de rocío",
  "units.distance": "Distancia",
  "units.downTrend": "abajo",
  "units.E": "E",
  "units.E_long": "Este",
  "units.ENE": "ENE",
  "units.ENE_long": "Este-Noreste",
  "units.ESE": "ESE",
  "units.ESE_long": "Este-Sureste",
  "units.ET": "Evapotranspiración",
  "units.ETshort": "hora del Este",
  "units.feelLike": "Feel-like",
  "units.feelsLike": "Feel-like",
  "units.footMile": "pie, milla",
  "units.frostPoint": "Punto de congelación",
  "units.gust": "Ráfaga",
  "units.heatIndex": "Índice de calor",
  "units.heatingDegreeDays": "Grados día de calefacción",
  "units.heatingPower": "Potencia de calefacción",
  "units.humidex": "Humidex",
  "units.humidity": "Humedad",
  "units.inch": "Pulgada",
  "units.inchOfMercury": "Pulgada de mercurio",
  "units.kilometerPerHour": "Kilómetro por hora",
  "units.knot": "Nudo",
  "units.last12Hours": "Últimas 12 horas",
  "units.last24Hours": "Últimas 24 horas",
  "units.last3Hours": "Últimas 3 horas",
  "units.last6Hours": "Últimas 6 horas",
  "units.lastHour": "Última hora",
  "units.lastLightningImpact": "último impacto",
  "units.lastMeasure": "Última medida",
  "units.leafSensors": "Sensores de hoja",
  "units.leafWetness": "Humedad de la hoja",
  "units.lightningDistance": "Distancia",
  "units.lightningStrikeCount": "recuentos de relámpagos",
  "units.lightningStrikeDistance": "distancia del rayo",
  "units.max": "Max.",
  "units.max_gust": "Max. ráfaga",
  "units.max_wind": "Viento máx.",
  "units.meterKilometer": "metros, kilómetros",
  "units.meterPerSecond": "Metro por segundo",
  "units.milePerHour": "Milla por hora",
  "units.millibar": "Millibar",
  "units.millimeter": "Milímetro",
  "units.millimeterOfMercury": "Milímetro de mercurio",
  "units.min": "Mín.",
  "units.N": "N",
  "units.N_long": "Norte",
  "units.NE": "NE",
  "units.NE_long": "Noreste",
  "units.NNE": "NNE",
  "units.NNE_long": "Norte-Noreste",
  "units.NNW": "NNW",
  "units.NNW_long": "Norte-Noroeste",
  "units.noise": "Ruido",
  "units.normalizedHeatingCoefficient": "Coeficiente de calentamiento normalizado",
  "units.NW": "NW",
  "units.NW_long": "Noroeste",
  "units.O3": "Ozono",
  "units.PM_1": "PM1",
  "units.PM_10": "PM10",
  "units.PM_2P5": "PM2.5",
  "units.precipitation": "Precipitaciones",
  "units.pressure": "Presión",
  "units.rain": "Lluvia",
  "units.rainRate": "Intensidad de lluvia",
  "units.referenceTemperature": "Temperatura de referencia",
  "units.relativePressure": "Presión relativa",
  "units.S": "S",
  "units.S_long": "Sur",
  "units.SE": "SE",
  "units.SE_long": "Sureste",
  "units.setPoint": "Establecida",
  "units.snow": "Nieve",
  "units.snowfall": "Nevada",
  "units.soilMoisture": "Humedad",
  "units.soilSensors": "Sensores de tierra",
  "units.solarEnergy": "Energía solar",
  "units.solarRadiation": "Radiación solar",
  "units.speed": "Velocidad",
  "units.SSE": "SSE",
  "units.SSE_long": "Sur-Sureste",
  "units.SSW": "SSW",
  "units.SSW_long": "Sur-Suroeste",
  "units.stableTrend": "estable",
  "units.sum": "Suma",
  "units.SW": "SW",
  "units.SW_long": "Sur oeste",
  "units.temperature": "Temperatura",
  "units.temperatureAndHumiditySensors": "Sensores de temperatura y humedad",
  "units.temperatureSensors": "Sensores de temperatura y humedad",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Hoy",
  "units.upTrend": "arriba",
  "units.uv": "ultravioleta",
  "units.visibility": "Vista",
  "units.W": "W",
  "units.W_long": "Oeste",
  "units.wetBulbGlobeTemperature": "Temperatura de globo de bulbo húmedo",
  "units.wetBulbTemperature": "Temperatura del bulbo húmedo",
  "units.wind": "Viento",
  "units.windChill": "Sensación térmica",
  "units.windDirection": "Dirección del viento",
  "units.windRun": "Distancia del viento",
  "units.windRunDescription": "La distancia del viento es la distancia total recorrida por el viento durante un período de tiempo",
  "units.WNW": "WNW",
  "units.WNW_long": "Oeste-Noroeste",
  "units.WSW": "WSW",
  "units.WSW_long": "Oeste-Suroeste"
}
